import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";
import store from "@/store";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.LIST_SET_FILTERS](state, { levyCollectionId }) {
    state.listing.levyCollectionId = levyCollectionId;
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_SUCCEEDED](state, logs) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = logs;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.EXPORT_SPREADSHEET_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SPREADSHEET_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_SPREADSHEET_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.EXPORT_JSON_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_JSON_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_JSON_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.VIEW_CLEAR](state) {
    state.view.loading = false;
    state.view.loaded = false;
    state.view.data = getBlankRecord();
  },
  [mutation.VIEW_NEXT](state, next) {
    stateMerge(state.view.next, next);
  },
  [mutation.VIEW_PREVIOUS](state, previous) {
    stateMerge(state.view.previous, previous);
  },
  [mutation.VIEW_STARTED](state, { levyCollectionId, noticeType }) {
    state.view.loading = true;
    state.view.levyCollectionId = levyCollectionId;
    state.view.noticeType = noticeType;
  },
  [mutation.VIEW_SUCCEEDED](state, template) {
    state.view.loading = false;
    state.view.loaded = true;
    stateMerge(state.view.data, template);
    state.view.breadcrumbs = [];
    state.view.breadcrumbs.push({
      text: `${template.levyCollection} levy collection setup`,
      path: `/levy-collections/${template.levyCollectionId}/setup/notices`
    });
    state.view.breadcrumbs.push({
      text: `${store.state.lookups.data.noticeTypeDescriptions[template.type]} template`
    });
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
    state.view.loaded = false;
  },

  [mutation.EDIT_SET_DATA](state, details) {
    stateMerge(state.edit.data, details);
  },
  [mutation.EDIT_GET_STARTED](state) {
    state.edit.loading = true;
    state.edit.isNew = false;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_GET_SUCCEEDED](state, template) {
    state.edit.loading = false;
    stateMerge(state.edit.data, template);
  },
  [mutation.EDIT_GET_FAILED](state) {
    state.edit.loading = false;
  },

  [mutation.EDIT_SAVE_STARTED](state, { type }) {
    state.edit.data.type = type;
    state.edit.saving = true;
    state.edit.error.show = false;
  },
  [mutation.EDIT_SAVE_SUCCEEDED](state, template) {
    state.edit.saving = false;
    stateMerge(state.edit.data, template);
  },
  [mutation.EDIT_SAVE_FAILED](state, error) {
    state.edit.saving = false;
    state.edit.error.show = true;
    state.edit.error.details = error;
  },

  [mutation.PREVIEW_GET_STARTED](state, { levyCollectionId, noticeType }) {
    state.preview.loading = true;
    state.preview.levyCollectionId = levyCollectionId;
    state.preview.noticeType = noticeType;
  },
  [mutation.PREVIEW_GET_SUCCEEDED](state, template) {
    state.preview.loading = false;
    state.preview.loaded = true;
    stateMerge(state.preview.data, template);
  },
  [mutation.PREVIEW_GET_FAILED](state) {
    state.preview.loading = false;
    state.preview.loaded = false;
  },

  [mutation.PREVIEW_SEND_EMAIL_STARTED](state) {
    state.emailPreview.sending = true;
  },
  [mutation.PREVIEW_SEND_EMAIL_SUCCEEDED](state) {
    state.emailPreview.sending = false;
  },
  [mutation.PREVIEW_SEND_EMAIL_FAILED](state) {
    state.emailPreview.sending = false;
  },

  [mutation.GET_SUBJECT_TAGS_STARTED](state) {
    state.subjectTags.loaded = false;
    state.subjectTags.loading = true;
    state.subjectTags.data = [];
  },
  [mutation.GET_SUBJECT_TAGS_SUCCEEDED](state, results) {
    state.subjectTags.loaded = true;
    state.subjectTags.loading = false;
    state.subjectTags.data = results;
  },
  [mutation.GET_SUBJECT_TAGS_FAILED](state) {
    state.subjectTags.loaded = false;
    state.subjectTags.loading = false;
    state.subjectTags.data = [];
  },

  [mutation.GET_BODY_TAGS_STARTED](state) {
    state.bodyTags.loaded = false;
    state.bodyTags.loading = true;
    state.bodyTags.data = [];
  },
  [mutation.GET_BODY_TAGS_SUCCEEDED](state, results) {
    state.bodyTags.loaded = true;
    state.bodyTags.loading = false;
    state.bodyTags.data = results;
  },
  [mutation.GET_BODY_TAGS_FAILED](state) {
    state.bodyTags.loaded = false;
    state.bodyTags.loading = false;
    state.bodyTags.data = [];
  }
};
